import Vue from "vue"

// 组件
import MsFooter from "../components/common/footer.vue"
import pagination from "../components/common/pagination"
import title from "../components/common/title.vue"
import noData from "../components/common/noData.vue"
import searchView from "../components/common/searchView.vue"
import uploadImg from "../components/common/upload/uploadImg"
import uploadAIImg from "../components/common/upload/uploadAIImg"
import uploadAudio from "../components/common/upload/uploadAudio"
import uploadFile from "../components/common/upload/uploadFile"
import uploadPdf from "../components/common/upload/uploadPdf"

// 函数
import emitter from "../mixins/emitter"
import log from "../mixins/methods/log"
import { navigationTo, navigationPropsTo } from "../mixins/methods/navigation"
import Throttle from '../mixins/methods/throttle'
import { amendCurrentPath, countDownFunc, formatTimer, messageAlert } from "../mixins/methods/common"
import { arrayUniq } from '../mixins/methods/listUniq'

// filters
import formatTime from '../mixins/filters/formatTime'
import toFixed2 from '../mixins/filters/toFixed'

// 其他
import { mapState, mapMutations } from "vuex";

/** 插件里面的组件以及mixin都是全局的在整个项目中都可以通过this.xxx访问 */
const commonPlugin = {
    install(Vue, options) {
        Vue.component('ms-footer', MsFooter); // 这里可以用来设置全局组件
        Vue.component('global-pagination', pagination);
        Vue.component('global-title', title);
        Vue.component('no-data', noData);
        Vue.component('global-search', searchView);
        Vue.component('global-uploadImg', uploadImg);
        Vue.component('global-uploadAIImg', uploadAIImg);
        Vue.component('global-uploadAudio', uploadAudio);
        Vue.component('global-uploadFile', uploadFile);
        Vue.component('global-uploadPdf', uploadPdf);
        Vue.mixin({
            data() {
                return {
                    globalTableLoading: false,
                }
            },
            filters: {
                formatTime,
                toFixed2
            },
            methods: {
                log,
                ...emitter,
                ...mapMutations(["amendState"]),
                log,
                navigationTo,
                navigationPropsTo,
                Throttle,
                amendCurrentPath,
                countDownFunc,
                formatTimer,
                messageAlert,
                arrayUniq,
                $showTableLoading() {
                    this.globalTableLoading = true;
                },
                $hideTableLoading() {
                    setTimeout(() => {
                        this.globalTableLoading = false;
                    }, 100)
                }
            },
        })
    }
}

export default commonPlugin;


// WEBPACK FOOTER //
// ./src/plugins/common.js